import momentGenerateConfig from "@rc-component/picker/generate/moment";
import generatePicker from "antd/es/date-picker/generatePicker";

const DatePicker = generatePicker(momentGenerateConfig);

export default DatePicker;
